import { Link } from 'react-router-dom';
import { Card } from '@medikei/ui';
import { Heart, FileText, Pill, Award } from 'lucide-react';

interface QuickLinksCardProps {
  className?: string;
}

const quickLinks = [
  {
    to: '/favoritos',
    icon: Heart,
    label: 'Favoritos',
    description: 'Seus médicos favoritos',
    color: 'bg-red-500/10 text-red-600 dark:text-red-400',
  },
  {
    to: '/historico',
    icon: FileText,
    label: 'Histórico',
    description: 'Consultas anteriores',
    color: 'bg-blue-500/10 text-blue-600 dark:text-blue-400',
  },
  {
    to: '/receitas',
    icon: Pill,
    label: 'Receitas',
    description: 'Suas receitas médicas',
    color: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400',
  },
  {
    to: '/atestados',
    icon: Award,
    label: 'Atestados',
    description: 'Seus atestados',
    color: 'bg-purple-500/10 text-purple-600 dark:text-purple-400',
  },
];

export function QuickLinksCard({ className = '' }: QuickLinksCardProps) {
  return (
    <Card className={`p-4 sm:p-6 rounded-2xl border border-border ${className}`}>
      <h3 className="font-bold text-lg mb-4 text-foreground">Acesso Rápido</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {quickLinks.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className="flex items-center gap-3 p-3.5 rounded-xl border border-border/70 hover:border-primary/40 bg-card hover:bg-muted/40 transition-colors"
          >
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${link.color}`}>
              <link.icon className="w-5 h-5" />
            </div>
            <div className="min-w-0 flex-1">
              <p className="font-semibold text-sm text-foreground truncate">{link.label}</p>
              <p className="text-xs text-muted-foreground truncate">{link.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </Card>
  );
}
